import React, { useCallback } from 'react';
import cx from 'classnames';
import Badge from '../../../Badge';
import { useTabs } from '../../context';
import styles from '../../Tabs.module.scss';
const Tab = ({ id, children, count, disabled }) => {
    const { activeTab, setActiveTab } = useTabs();
    const isActive = activeTab === id;
    const handleClick = useCallback(() => {
        if (disabled)
            return;
        setActiveTab(id);
    }, [disabled, id, setActiveTab]);
    return (React.createElement("button", { type: "button", onClick: handleClick, disabled: disabled, className: cx(styles.tab, {
            [styles.active]: isActive,
            [styles.disabled]: disabled,
        }) },
        children,
        count && React.createElement(Badge, { status: "process", value: count })));
};
export default Tab;
